module.exports = __webpack_public_path__ + "img/s3_v1.6d5aa70a.png";